import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ShoppableOutfit from '@stitch-fix/mode-react/ShoppableOutfit';
import useOutfitSandboxQuery from '../ProductDetailsPage/useOutfitSandboxQuery';
import { shopPdpPath } from '../../utils/urlUtils';
import styles from './styles.module.scss';

const OutfitSandboxSideBySideComparison = ({ outfitId, title }) => {
  const [
    outfitGeneratedByCurrentAlgorithm,
    setOutfitGeneratedByCurrentAlgorithm,
  ] = useState(null);

  const [
    outfitGeneratedByExperimentalAlgorithm,
    setOutfitGeneratedByExperimentalAlgorithm,
  ] = useState(null);

  const { outfitSandboxData } = useOutfitSandboxQuery({
    outfitId,
  });

  useEffect(() => {
    if (outfitSandboxData) {
      setOutfitGeneratedByCurrentAlgorithm(
        outfitSandboxData?.client?.outfitSandbox?.legacyOutfit || null,
      );
      setOutfitGeneratedByExperimentalAlgorithm(
        outfitSandboxData?.client?.outfitSandbox?.outfit || null,
      );
    }
  }, [outfitSandboxData]);

  const buildOutfitImageComponents = outfit =>
    outfit?.items?.map(item => {
      const sku = item?.shopProductVariant;

      if (!sku) {
        // Shop Product Catalog may not have imported the variant yet
        return null;
      }

      // TODO: primaryImage can technically be null here, which would cause an error.
      const primaryImage = sku?.image;
      const fallbackUrl = `${primaryImage?.baseUrl}${primaryImage?.mediaPath}`;
      const imageUrl = primaryImage?.medium || fallbackUrl;

      return {
        id: sku?.id,
        imageUrl,
        altText: primaryImage?.altText,
        labelText: item?.sticker?.label,
        laydown: item?.laydown,
        url: shopPdpPath(sku?.url, {
          source: 'outfit-sandbox',
          subSource: 'outfit-sandbox',
          outfitId: outfit.id,
          collection: 'outfit-sandbox',
          queryId: null,
        }),
      };
    }) || [];

  return (
    <>
      <hr className={styles.sandbox_divider} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.title}>Outfit Id: {outfitId}</p>
      <div className={styles.main_outfits_container}>
        <div styleName="box">
          <p className={styles.title}>Legacy Outfit Laydown</p>
          <ShoppableOutfit
            outfitId={outfitGeneratedByCurrentAlgorithm?.id || ''}
            imageComponents={buildOutfitImageComponents(
              outfitGeneratedByCurrentAlgorithm,
              item => !!item?.id,
            )}
            isLoading={false}
          />
        </div>
        <div styleName="box">
          <p className={styles.title}>Experimental Outfit Laydown</p>
          <ShoppableOutfit
            outfitId={outfitGeneratedByExperimentalAlgorithm?.id || ''}
            imageComponents={buildOutfitImageComponents(
              outfitGeneratedByExperimentalAlgorithm,
              item => !!item?.id,
            )}
            isLoading={false}
          />
        </div>
      </div>
    </>
  );
};

OutfitSandboxSideBySideComparison.propTypes = {
  title: PropTypes.string.isRequired,
  outfitId: PropTypes.string.isRequired,
};

export default OutfitSandboxSideBySideComparison;
